module.exports = {
	data () {
	   return {
	     seo_title:'Full-Service Advertising Agency | Marcus Thomas LLC',
	     seo_description:'',
	     seo_keywords:'',
	     page_title:'Marketing Solutions | Integrated Advertising Agency | Marcus Thomas LLC',
	     og_title: '',
	     og_url: '',
	     og_image: ''
	   }
	 },
	head:{
		title:function() {
			return{
	      		inner: this.page_title,
						separator: ' '
	      	}
	    },
		meta:function(){
			return[
			{ name: 'description', content: this.seo_description, id: 'desc' },
			{ name: 'keywords', content: this.seo_keywords, id: 'keywords' },
			{ name: 'title', content: this.seo_title, id:'title'},
			{ id: 'ogtitle', content: this.og_title },
			{ id: 'ogurl', content: this.og_url },
			{ id: 'ogimage', content: this.og_image }
		]}
	}
}



// WEBPACK FOOTER //
// ./src/mixins/seoModule.js